<div class="x-file-preview-tabs" *ngIf="items?.length > 1">
    <button *ngFor="let i of items" nz-button nzType="text" nzSize="small" class="x-file-preview-tab"
        [class.active]="i.id === activeItem?.id" [nz-tooltip]="i.name" (click)="selectItem(i)">
        {{ i.name }}
    </button>
</div>

@defer (on idle) {
    <ngx-extended-pdf-viewer [id]="viewerId" zoom="auto" [base64Src]="previewContent" [showRotateButton]="false"
        [showOpenFileButton]="false" [showPrintButton]="false" [showPropertiesButton]="false" [textLayer]="true"
        [showHandToolButton]="true" [handTool]="false">
    </ngx-extended-pdf-viewer>
}

<ng-template #nzTitle>
    <div nz-row>
        <div nz-col nzFlex="auto">
            {{ activeItem?.name }}
        </div>
        <div nz-col>
            <button nz-button nzType="text" nzSize="small" (click)="windowResize()"
                [nz-tooltip]="this.filePrevSize === '50%' ? 'Maximize' : 'Restore'">
                <i class="fa {{ this.filePrevSize === '50%' ? 'fa-window-maximize' : 'fa-window-restore' }}"
                    aria-hidden="true"></i>
            </button>
        </div>
        <div nz-col nzFlex="35px"></div>
    </div>
</ng-template>